export const emailStepText = {
  head: "Eitt í viðbót",
  main: "Vinsamlegast skráðu upplýsingarnar þínar svo hægt sé að senda nótur, pöntunarstaðfestingar, BYKO kort o.fl.",
};
